import TransactionForInvoiceDatagrid from '../DatagridEntity/TransactionsForFundraisingDatagrid';

const FundraisingTransactionsPage = () => (<TransactionForInvoiceDatagrid />);
export default FundraisingTransactionsPage;
